import { Link } from "react-router-dom";
import { articles } from "@/mocks/gossip";
import ArticleCard from "@/components/base/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";

const hotArticles = articles.filter((item) => item.hot);
const featureArticle = hotArticles[0] ?? articles[0];
const sideList = hotArticles.slice(1, 4);
const gridArticles = articles.filter((item) => item.id !== featureArticle.id && !sideList.includes(item)).slice(0, 3);

export default function HotSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50" aria-labelledby="hot-heading">
      <SectionHeading
        kicker="Today's Hot"
        title="今日热门大瓜，讨论度最高的都在这"
        desc="按当日讨论热度排序，配合编辑校对过的时间线。点开任意一条，都能看到完整的事件脉络与信息来源说明。"
        linkTo="/hot"
        linkLabel="查看全部猛料"
      />
      <h2 id="hot-heading" className="sr-only">
        今日热门大瓜
      </h2>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <div className="lg:col-span-8">
          <ArticleCard article={featureArticle} variant="feature" />
        </div>

        <div className="lg:col-span-4 bg-background-100 border border-background-200 rounded-lg p-5 md:p-6">
          <h3 className="font-heading text-base font-semibold text-foreground-950 mb-3 inline-flex items-center gap-2">
            <i className="ri-bookmark-3-line text-accent-600"></i>
            编辑精选 · 正在跟进
          </h3>
          <p className="text-xs text-foreground-500 leading-relaxed mb-2">
            这几条仍在更新中，编辑会持续补充新的公开信息。
          </p>
          <div>
            {sideList.map((item) => (
              <ArticleCard key={item.id} article={item} variant="compact" />
            ))}
          </div>
          <Link
            to="/hot"
            className="mt-4 inline-flex items-center gap-1.5 text-sm font-label font-medium text-primary-700 hover:text-primary-800 transition-colors cursor-pointer"
          >
            更多跟进中的瓜料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {gridArticles.map((item) => (
          <ArticleCard key={item.id} article={item} />
        ))}
      </div>

      <div className="mt-10 flex flex-wrap items-center gap-3 justify-center">
        <span className="text-sm font-label text-foreground-500">热门标签：</span>
        {["路透", "时间线", "口碑", "剪辑", "现场"].map((tag) => (
          <Link
            key={tag}
            to={`/hot?q=${encodeURIComponent(tag)}`}
            className="px-3 py-1.5 text-xs font-label rounded-full bg-secondary-100 text-secondary-900 hover:bg-secondary-200 transition-colors cursor-pointer"
          >
            #{tag}
          </Link>
        ))}
      </div>
    </section>
  );
}